import { styled } from "@mui/material/styles";
import Box, { BoxProps } from "@mui/material/Box";
import {IDragDropLabelProps} from "./types";


export const DragDropContainer = styled(Box)<BoxProps>(({ theme }) => ({
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    alignItems: 'center',
    position: 'absolute',
}));

export const BoxNoMouseEvents = styled(Box)<BoxProps>(({ theme }) => ({
    pointerEvents: 'none',
}));

export const DragDropLabel = styled('label')<IDragDropLabelProps>(({theme, isDragOver}) => ({
    cursor: 'pointer',
    textAlign: 'center',
    display: 'flex',
    '& p, & svg': {
        opacity: isDragOver ? 1.0 : 0.4,
    },
    '&:hover p,&:hover svg': {
        opacity: 1.0,
    },
}));
